
import { filter } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener } from '@angular/core';
import { HttpServices } from '../services/http.service';
import { FournisseurService } from '../services/fournisseur.service';
import { PanierService } from '../services/panier.service';
import { Subscription, Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { PaymentCard, PaymentMethod, PanierState, Panier } from '../models';
import { PaymentOrder } from '../models';
import * as config from '../config/config';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Right } from '../models/Rights.enum';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import { CreditCardsService } from '../services/credit-cards.service';
import { LoaderService } from '../services/loader.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { TrackingService } from '../services/tracking.service';

@Component({
  selector: 'fs-payment-cards',
  styleUrls: ['./payment-cards.sass'],
  templateUrl: './payment-cards.component.html',
  encapsulation: ViewEncapsulation.None
})
export class PaymentCardsComponent implements OnInit, OnDestroy {
  rights = Right;
  urlPayment: SafeResourceUrl = null;
  orderIdPayment: number = null;
  supplierListCards: PaymentCard[];
  canLeave: boolean = false;
  faChevronLeft = faChevronLeft;
  defaultCardId: number;
  selectedCardId: number;
  PaymentMethod = PaymentMethod;
  selectedPaymentMethod: PaymentMethod;
  activeSupplierId: number;
  cardsList: PaymentCard[];
  cartContent: Panier;
  cartAmount: number;
  payDisabled = true;
  targetPage;
  targetPageSubscription: Subscription;
  cardToRemove;

  constructor(
    private httpServices: HttpServices,
    private fournisseurService: FournisseurService,
    private loaderService: LoaderService,
    private panierService: PanierService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private creditCardsService: CreditCardsService,
    private ngxSmartModalService: NgxSmartModalService,
    private trackingService: TrackingService
  ) {
    this.targetPageSubscription = router.events.pipe(
      filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => this.targetPage = event.url);
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(resolvedData => {
      this.cardsList = resolvedData.selectPayInfos.cardsList;
      this.defaultCardId = resolvedData.selectPayInfos.defaultCardId;
      this.activeSupplierId = this.fournisseurService.getActiveSupplierId();
      this.cartContent = this.panierService.getCartContent();
      this.cartAmount = this.panierService.getCartAmount();
      this.trackingService.pushEvent('financial-online_payment-step2');
      this.loaderService.decreaseLoaderCount();
    });
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.canLeave) {
      this.ngxSmartModalService.open('selectPayMeanExitModal');
    }
    return this.canLeave;
  }

  onClickRemoveCard(cardsInfos: any) {
    this.cardToRemove = cardsInfos;
    this.ngxSmartModalService.open('removeCardModal');
  }

  onRemoveCardConfirmed() {
    this.loaderService.increaseLoaderCount();
    this.creditCardsService.removeCard(this.cardToRemove.cardId).subscribe(response => {
      if (response) {
        const removeIndex = this.cardsList.findIndex(card => card.PaymentMethodCardId === this.cardToRemove.cardId);
        this.cardsList.splice(removeIndex, 1);
        this.defaultCardId = this.defaultCardId === this.cardToRemove.cardId ? null : this.defaultCardId;
        if (this.selectedCardId === this.cardToRemove.cardId) {
          this.payDisabled = true;
          this.selectedCardId = null;
          this.selectedPaymentMethod = null;
        }
        this.ngxSmartModalService.close('removeCardModal');
        this.loaderService.decreaseLoaderCount();
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event: BeforeUnloadEvent) {
    event.returnValue = ' ';
    return ' ';
  }

  onClickBackBtn() {
    this.canLeave = true;
    this.router.navigate(['/balance-outstanding']);
  }

  onClickPay(): void {
    this.canLeave = true;
    switch (this.selectedPaymentMethod) {
      case PaymentMethod.Card:
        this.payWithCreditCard(this.selectedCardId);
        break;

      default:
        break;
    }
  }

  payWithCreditCard(cardId?: number): void {
    this.loaderService.increaseLoaderCount();
    const params = [
      { 'Key': 'idFournisseur', 'Value': String(this.activeSupplierId) },
      { 'Key': 'amount', 'Value': String(this.cartAmount) }
    ];
    if (cardId) {
      params.push({ 'Key': 'CardId', 'Value': String(cardId) });
    }
    this.httpServices.put<any, PaymentOrder>(config.ApiKeys.PUT_PAY, '', () => { }, params).subscribe(order => {
      this.panierService.setCartState(PanierState.PAY_IN_PROGRESS);
      this.canLeave = true;
      this.router.navigate(['/payment-iframe'], {
        queryParams: {
          iframeUrl: order.Url,
          supplierId: order.IdFournisseur,
          amount: order.MontantTtc,
          orderId: order.PaymentOrderId
        }
      });
      this.loaderService.decreaseLoaderCount();
    });
  }

  onClickCard(cardsInfos: any) {
    this.payDisabled = false;
    this.selectedPaymentMethod = PaymentMethod.Card;
    this.panierService.setPaymentMethod(PaymentMethod.Card);
    this.selectedCardId = cardsInfos.cardId;

    if (cardsInfos.cardId !== this.defaultCardId) {
      this.loaderService.increaseLoaderCount();
      this.creditCardsService.putDefaultCard(cardsInfos.cardId).subscribe(response => {
        if (response) {
          this.defaultCardId = cardsInfos.cardId;
          this.loaderService.decreaseLoaderCount();
        }
      });
    }
  }

  onClickNewCard() {
    this.selectedPaymentMethod = PaymentMethod.Card;
    this.payDisabled = false;
    this.payWithCreditCard();
  }

  onSelectPayMeanExitConfirmed(): void {
    this.loaderService.increaseLoaderCount();
    this.httpServices.put<any, any>(
      config.ApiKeys.PUT_CLEAR_PAYEMENT,
      '',
      () => { },
      [{ 'Key': 'idFournisseur', 'Value': String(this.activeSupplierId) }]
    ).subscribe(() => {
      this.canLeave = true;
      this.router.navigate([this.targetPage]);
      this.ngxSmartModalService.close('selectPayMeanExitModal');
      this.loaderService.decreaseLoaderCount();
    });
  }

  ngOnDestroy() {
    this.targetPageSubscription.unsubscribe();
  }
}
